export default __webpack_public_path__ + "static/media/foto-perfil-random.2fda6558.png";